/** @jsx h */

// compare widget
import { h, render, Component } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconTrash from '../IconTrash';
import IconClose from '../IconClose';

import { textBlack } from '../../../styles/scss/_colors.scss';
import styles from '../../styles.scss';

class ComparisonWidget extends Component {
    render() {
        const {
            skusCount,
            compareURL,
            handleCloseComparison,
            clearClickHandler,
            translationsMap,
        } = this.props;

        const compareLintStyles = classNames({
            [styles.comparisonLink]: true,
            [styles.comparisonLink_dark]: true,
            'analytics-compare-now': true,
        });
        const productCountStyles = classNames({
            [styles.productCount]: true,
            'analytics-compare-count': true,
        });
        const compareCloseStyles = classNames({
            [styles.comparisonCloseIcon]: true,
            'analytics-compare-close': true,
        });
        const compareClearListStyles = classNames({
            [styles.comparisonClearList]: true,
            'analytics-clear-list': true,
        });

        return (
            <div className={styles.comparisonContent}>
                <div className={styles.comparisonInfo}>
                    <div className={styles.comparisonCount}>
                        <span className={styles.productLabel}>
                            {`${translationsMap['apc.comparison.products_to_compare']}: `}
                        </span>
                        <span className={productCountStyles}>{skusCount}</span>
                    </div>
                    <div
                        className={compareClearListStyles}
                        onClick={clearClickHandler}
                        role="button"
                        aria-pressed={false}
                    >
                        <span className={styles.comparisonClearIcon}>
                            <IconTrash fill={textBlack} width={15} height={15} />
                        </span>
                        <span className={styles.comparisonClearLabel}>
                            {translationsMap['apc.comparison.clear_list']}
                        </span>
                    </div>
                </div>
                <div className={styles.comparisonActions}>
                    {/* "onTouchStart" is a fix for iOS devices. Without it css :active doesn't work */}
                    <a href={compareURL} className={compareLintStyles} onTouchStart={() => {}}>
                        {translationsMap['apc.comparison.compare_now']}
                    </a>
                    <span className={compareCloseStyles} onClick={handleCloseComparison}>
                        <IconClose fill="#99821A" />
                    </span>
                </div>
            </div>
        );
    }
}

ComparisonWidget.propTypes = {
    skusCount: PropTypes.number.isRequired,
    compareURL: PropTypes.string.isRequired,
    handleCloseComparison: PropTypes.func.isRequired,
    clearClickHandler: PropTypes.func.isRequired,
    translationsMap: PropTypes.object.isRequired,
};

ComparisonWidget.defaultProps = {
    skusCount: 0,
    handleCloseComparison: () => {},
    clearClickHandler: () => {},
    translationsMap: {
        'apc.comparison.clear_list': 'Clear List',
        'apc.comparison.compare_now': 'Compare Now',
        'apc.comparison.products_to_compare': 'Products to compare',
    },
};

export default ComparisonWidget;
